import React from "react"
import "./getInTouch.css"

const emailAddress = "rahul.vagadiya@gmail.com"
const projectEmail = `mailto:${emailAddress}?subject=${encodeURIComponent(
  "Project enquiry — 30-minute consultation"
)}`
const calendlyUrl = "https://calendly.com/rahulv/30min"

const GetInTouch = () => {
  return (
    <section
      className="get-in-touch"
      aria-labelledby="project-consultation-title"
    >
      <h2 id="project-consultation-title" className="no-curlys">Have a project in mind?</h2>
      <p className="get-in-touch__copy">
        Building an app or AI product? Let’s discuss how to take it from idea to
        release.
      </p>
      <div className="get-in-touch__actions">
        <a
          className="get-in-touch__button"
          href={calendlyUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Book a 30-minute call
        </a>
        <a className="get-in-touch__email" href={projectEmail}>
          or email me
        </a>
      </div>
    </section>
  )
}
export default GetInTouch
